// Lightweight customer session — single orderId in localStorage.
// Auto-expires after 7 days of inactivity (any successful API call refreshes lastActiveAt).
const KEY = "ph-customer-session";
const TTL_DAYS = 7;

export function saveSession(session) {
  try {
    const enriched = { ...session, lastActiveAt: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(enriched));
  } catch (_e) {
    /* localStorage unavailable */
  }
}

export function touchSession() {
  // Mark activity so the 7-day idle window resets.
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return;
    const obj = JSON.parse(raw);
    obj.lastActiveAt = new Date().toISOString();
    localStorage.setItem(KEY, JSON.stringify(obj));
  } catch (_e) {
    /* noop */
  }
}

export function getSession() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    const last = obj.lastActiveAt ? new Date(obj.lastActiveAt).getTime() : 0;
    const ageDays = (Date.now() - last) / (1000 * 60 * 60 * 24);
    if (ageDays > TTL_DAYS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return obj;
  } catch (_e) {
    return null;
  }
}

export function clearSession() {
  try {
    localStorage.removeItem(KEY);
  } catch (_e) {
    /* noop */
  }
}
